<div class="sidebar-container">
  <div class="buttons-container">
    @for (button of controlButtons; track button) {
      <abc-button
        class="control-button"
        [class]="button.active ? 'active' : ''"
        (click)="button.action()"
        [stylingMode]="'text'"
        type="normal"
        [icon]="button.icon"
        [text]="button.text"
        [visible]="button.visible"
      ></abc-button>
    }
  </div>
</div>
